"use strict";

if (document.querySelector('.gallery-slider')) {
  var thumbs = document.querySelector('.gallery-thumb .swiper-container');
  var next = document.querySelector('.gallery-thumb .swiper-button-next');
  var prev = document.querySelector('.gallery-thumb .swiper-button-prev');
  var thumbsSwiper = new Swiper(thumbs, {
    pagination: false,
    direction: "vertical",
    loop: false,
    speed: 1000,
    allowTouchMove: true,
    slidesPerView: 'auto',
    autoplay: false,
    spaceBetween: 20,
    lazy: {
      loadPrevNext: true
    },
    disableOnInteraction: false,
    waitForTransition: true,
    navigation: false
  });
  var gallerySwiper = [];
  document.querySelectorAll('.gallery-slider').forEach(function (item, index) {
    var slider = item.querySelector('.swiper-container');
    var next = item.querySelector('.swiper-button-next');
    var prev = item.querySelector(' .swiper-button-prev');
    gallerySwiper[index] = new Swiper(slider, {
      speed: 1000,
      pagination: false,
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: false,
      lazy: {
        loadPrevNext: true
      },
      autoplay: false,
      disableOnInteraction: false,
      waitForTransition: true,
      thumbs: {
        swiper: thumbsSwiper,
        autoScrollOffset: 1
      }
    });
    $(document).on('msoptionsprice_product_action', function (e, action, form, r) {
      if (action == 'modification/get' && r.success && r.data) {
        var m = r.data.modification || {};
        var image_id = m.image;
        if (image_id) {
          gallerySwiper[index].slideTo($('.gallery-slider .swiper-slide[data-iid="' + image_id + '"]').index());
        }
      }
    });
  });
}
$(document).on('click', '.product__tabs-nav-item', function () {
  var parent = $(this).closest('.product__content');
  var id = $(this).data('id');
  if (!$(this).hasClass('active')) {
    $(parent).find('.product__tabs-nav-item').removeClass('active');
    $(this).addClass('active');
    $(parent).find('.product__tab').hide();
    $(parent).find('.product__tab[data-id="' + id + '"]').fadeIn(300);
  }
});
$(document).on('click', '.product__char-more', function () {
  $('.product__tabs-nav-item').removeClass('active');
  $('.product__tabs-nav-item[data-id="char"]').addClass('active');
  $('.product__tab').hide();
  $('.product__tab[data-id="char"]').fadeIn(300);
  $('body, html').animate({
    scrollTop: $('.product__content').offset().top
  }, 150);
});